import { useQuery, useMutation } from "./urqlHooks";

const AREAS = `query AllCashflowAreas ($companyId: String!) {
    allCashflowAreas (companyId: $companyId){
      id
      name
      category
      label
    }
  }
  `;

export const GetAreas = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: AREAS,
    variables: { companyId },
    pause: !companyId || companyId === null || companyId === undefined, // Skip query when no companyId is provided
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const INITIALBALANCE = `mutation CreateInitialBalanceDocument(
    $amount: Float!
    $documentDate: DateTime!
    $companyId: String!
    $name: String!
    $description: String
    $currencyType: SupportedCurrency!
    $isBanking: Boolean
  ) {
    createInitialBalanceDocument(
      input: {
        name: $name
        description: $description
        amount: $amount
        currencyType: $currencyType
        companyId: $companyId
        documentDate: $documentDate
        isManual: true
        documentType: MANUAL
        meta: { initialBalance: true isBanking: $isBanking }
      }
    ) {
      id
    }
  }`;

export const PostInitialBalance = () => {
  const [_updatePostInitialBalance, postInitialBalance] =
    useMutation(INITIALBALANCE);
  return postInitialBalance;
};

const MANUALDOCUMENT = `mutation CreateManualDocument(
    $amount: Float!
    $documentDate: DateTime!
    $companyId: String!
    $cashflowAreaId: ID!
    $meta: ManualMetaInput!
    $name: String
    $description: String
    $currencyType: SupportedCurrency!
    $emissionDate: DateTime
  ) {
    createManualDocument(
      input: {
        name: $name
        description: $description
        amount: $amount
        documentDate: $documentDate
        companyId: $companyId
        cashflowAreaId: $cashflowAreaId
        isManual: true
        documentType: MANUAL
        meta: $meta
        currencyType: $currencyType
        emissionDate: $emissionDate
      }
    ) {
      id
    }
  }`;

export const PostManualDocument = () => {
  const [_updatePostManualDocument, postManualDocument] =
    useMutation(MANUALDOCUMENT);
  return postManualDocument;
};

const CREDITDOCUMENT = `mutation ADD_CREDIT($companyId: String!, $credit: CreditInput! ) {
    addCredit(companyId: $companyId, credit: $credit) {
        id
    }
}`;

export const CreateCreditsDocument = () => {
  const [_updateCreateCreditsDocument, createCreditsDocument] =
    useMutation(CREDITDOCUMENT);
  return createCreditsDocument;
};
